<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>

@if (IsInDesignMode) {
  <div class="grid-design-div" data-grid-type="contact-grid">
    <div class="{{this.Mode =='design' ? 'design-mode-field-label' : 'field-label'}}">@if (this.ShowLabel) {
      <mat-label>{{this.DisplayName}} @if (this.FormField.required) {
        <span style="color: #EF0000;">*</span>
      }</mat-label>
    }</div>
    <app-grid-field-designer #gridFieldDesigner
      [gridFormFieldComponent]="WrappedGridFormFieldComponent"
      (initialized)="handleGridFieldFieldDesignerInit()"
      (onEdit)="handleEditFieldProperty($event)">
    </app-grid-field-designer>
    <!-- Define a design mode context menu. -->
    <mat-menu #gridCellContextMenu="matMenu">
      <ng-template matMenuContent let-row="row">
        <button mat-menu-item
          [disabled]="false"
          (click)="this.gridCellContextMenuItemClicked($event,'Properties ...')">
          Properties ...
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item
          [disabled]="false"
          (click)="this.gridCellContextMenuItemClicked($event,'Delete')">
          Delete
        </button>
      </ng-template>
    </mat-menu>
    <!-- Define a menu trigger. -->
    <div style="visibility: hidden; position: fixed"
      [style.left]="this.ContextMenuPositionX"
      [style.top]="this.ContextMenuPositionY"
      [matMenuTriggerFor]="gridCellContextMenu">
    </div>
    <!---END DESIGN MODE CONTEXT MENU-->
  </div>
}

@if (IsInPreviewOrInstanceMode) {
  <div class="preview-and-instance-modes-div" data-grid-type="contact-grid">
    @if (this.DisplayName) {
      <div class="field-label">{{this.DisplayName}}</div>
    }
    <button [disabled]="FormField.readOnly" mat-stroked-button style="margin:10px;" (click)="openNewContactDialog()">New Contact</button>
    <button [disabled]="FormField.readOnly" mat-stroked-button style="margin:10px;" (click)="addMeButtonClicked()">Add Me</button>
    <!--[disabled]="this.EmailAllButtonDisabled"-->
    <button mat-stroked-button style="margin:10px;"
      title="{{this.EmailAllToolTip}}"
      matTooltip="{{this.EmailAllToolTip}}"
      [matTooltipPosition]="this.TooltipPosition"
      (click)="this.generateClientSideEmail()">
      Email All Contacts
    </button>
    <button mat-stroked-button style="margin:10px;"
      title="{{this.AutomatedNotificationToolTip}}"
      matTooltip="{{this.AutomatedNotificationToolTip}}"
      [matTooltipPosition]="this.TooltipPosition"
      (click)="this.automatedNotificationDialog()">
      Automated Notification
    </button>
    <app-grid-field-editor #gridFieldEditor
      [flavor]="ContactsGridFlavor"
      [formInstance]="FormInstance"
      [gridFormFieldComponent]="WrappedGridFormFieldComponent"
      [isFootnotesGrid]="false"
      (editorInitialized)="WrappedGridFormFieldComponent.setGridFieldEditorComponent($event)"
      (editorGridValidation)="this.handleEditorGridValidation($event)"
      (conditionalLogicColumnDefsFilter)="this.handleConditionalLogicColumnDefsFilter($event)">
    </app-grid-field-editor>
  </div>
}
